// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 279 ? "6c44d60f" : chunkId) + "." + {"229":"6dca8f8fcab4e1b8","279":"19563b860705d874"}[chunkId] + ".js";
};